export const List = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 7H28" stroke="currentColor" stroke-width="2"/>
<path d="M10 16H28" stroke="currentColor" stroke-width="2"/>
<path d="M10 25H28" stroke="currentColor" stroke-width="2"/>
<rect x="4.5" y="6.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="4.5" y="15.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="4.5" y="24.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
</svg>`;
